import {
  addDays,
  formatISO,
  isSameDay,
  isValid,
  parseISO,
  startOfDay,
  subMilliseconds,
} from "date-fns";

// The API range is [start, end); the calendar displays both selected days.
export const parseContactDateRange = (range = "") => {
  const [start, end] = range?.split(",") ?? [];
  const parsedStart = start ? parseISO(start) : null;
  const parsedEnd = end ? parseISO(end) : null;

  if (!isValid(parsedStart) || !isValid(parsedEnd) || parsedStart >= parsedEnd) {
    return { startDate: null, endDate: null };
  }

  return {
    startDate: startOfDay(parsedStart),
    endDate: startOfDay(subMilliseconds(parsedEnd, 1)),
  };
};

export const buildContactDateRange = (startDate, endDate, originalRange = "") => {
  if (!isValid(startDate) || !isValid(endDate) || startOfDay(startDate) > startOfDay(endDate)) {
    return "";
  }

  const originalDates = parseContactDateRange(originalRange);
  if (isSameDay(startDate, originalDates.startDate) && isSameDay(endDate, originalDates.endDate)) {
    // Preserve the backend's exact bounds and timezone until the user changes days.
    return originalRange;
  }

  return `${formatISO(startOfDay(startDate))},${formatISO(addDays(startOfDay(endDate), 1))}`;
};
